<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 50065 35368"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <g id="_843921168">
     <path class="fil0" d="M0 17566c0,1906 1585,3323 3561,3323l42964 0c4407,0 5189,-6409 -475,-6409l-42015 0c-1128,0 -2144,235 -2798,762 -520,419 -1237,1513 -1237,2324z"/>
     <path class="fil0" d="M0 32283c0,1591 1285,3085 2848,3085l44389 0c3520,0 3829,-6171 0,-6171l-44389 0c-1533,0 -2848,1573 -2848,3086z"/>
     <path class="fil0" d="M0 3086c0,1592 1285,3086 2848,3086l44389 0c3584,0 4021,-6172 -475,-6172l-43439 0c-1839,0 -3323,1319 -3323,3086z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'HamburgerMenu',
};
</script>

<style scoped>
.fil0 {fill:#666666}
</style>
